import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CustomToggleButtonProperties {
  labels: string[] | undefined;
  icons?: JSX.Element[];
  activeIcons?: JSX.Element[];
  onToggle?: (index: number, label: string) => void;
  defaultActiveIndex?: number;
  type?: 'chart';
  version?: string;
  hoverIcons?: JSX.Element[]; // NEW
}
/**
 * custom
 * Custom toggle button function component
 */
function CustomToggleButton({
  labels,
  icons,
  activeIcons,
  onToggle,
  defaultActiveIndex,
  type,
  version,
  hoverIcons,
}: CustomToggleButtonProperties) {
  const { t, i18n } = useTranslation('sharedComp');
  const [activeIndex, setActiveIndex] = useState(0);
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  /**
   * toggle
   */
  const handleToggle = (index: number, label: string) => {
    setActiveIndex(index);
    if (onToggle) {
      onToggle(index, label);
    }
  };

  useEffect(() => {
    if (defaultActiveIndex) {
      setActiveIndex(defaultActiveIndex);
    }
  }, [defaultActiveIndex]);

  /**
   * renderIcon
   * @param index \
   * @returns
   */
  const renderIcon = (index: number) => {
    if (activeIndex === index && activeIcons?.[index]) {
      return <span className="icon active-icon">{activeIcons[index]}</span>;
    }
    if (hoverIndex === index && hoverIcons?.[index]) {
      return <span className="icon hover-icon">{hoverIcons[index]}</span>;
    }

    if (icons?.[index]) {
      return <span className="icon">{icons[index]}</span>;
    }

    return null;
  };

  return (
    <div className="toggle-button-container" dir={i18n.dir()}>
      <div className={`toggle-button-${version} ${type}`}>
        {labels?.map((label, index) => (
          <div
            className={`btn ${activeIndex === index ? 'active' : ''}`}
            onClick={() => handleToggle(index, label)}
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(null)}
            role="presentation">
            {renderIcon(index)}
            {t(label)}
          </div>
        ))}
        <span className="toggle-button-border"> </span>
      </div>
    </div>
  );
}
CustomToggleButton.defaultProps = {
  defaultActiveIndex: 0,
  icons: undefined,
  activeIcons: undefined,
  onToggle: undefined,
  type: '',
  version: 'v1',
  hoverIcons: undefined, // NEW
};
export default CustomToggleButton;
